import { changePatientdefault, patientdelete } from "server/mine";
import { getPatientlist } from "server/login";
import Vue from 'vue'
import router from "router/index";
import { Dialog } from 'vant';
const v = new Vue()

/**
 * 找到默认就诊人
 * @param userList
 * @returns {any}
 */
const findDefaultUser = (userList) => {
  if (!Array.isArray(userList)) {
    console.log('用户列表必须是一个数组')
    // v.$toast('用户列表必须是一个数组')
  }

  //这里是就诊卡组件显示的默认就诊人信息 比如首页
  //有就诊人且全部is_default都为0 没有默认就诊人 拿第一个为默认就诊人
  // console.log("没有默认就诊人=>", userList.every((item) => item.is_default === 0));
  if (userList.length != 0 && userList.every((item) => item.is_default === 0)) {
    console.log("有就诊人列表但是没有默认就诊人");
     //切换第一个为默认就诊人
    console.log("userList[0].id",userList[0].id);
    changePatientdefault({ patient_id: userList[0].id }).then((res)=>{
      console.log("有就诊人列表没有默认就诊人手动切换第一个就诊人，切换成功");
    })
    return userList[0]
  }

  for (let item of userList) {
    if (item.is_default === 1) {
      return item
    }
  }

  return undefined
}


export default {
  /**
   * 切换默认就诊人
   * @param state
   * @param commit
   * @param index 被选中的就诊人
   * @returns {Promise<void>}
   */
  async changeDefaultUser({ state, commit, dispatch }, index) {
    return new Promise(async (resolve, reject) => {
      await changePatientdefault({ patient_id: state.userInfoList[index].id }).then((res) => {
        dispatch('getAllUser', { isReFlush: true }).then((res) => {
          commit('setUserInfo', state.userInfoList[index])
          v.$toast("切换成功");
          resolve(res)
        }).catch((e) => {
          v.$toast(e);
          reject(e)
        })
      }).catch((e) => {
        v.$toast("切换失败，请重试！");
        reject(e)
      });
    })

  },

  /**
   * 获取所有就诊人
   * @param state
   * @param commit
   * @param {object} options  isReFlush是否强制刷新不从vuex获取,isPush是否进入建卡页面
   * @returns {Promise<void>}
   */
  async getAllUser({ state, commit }, options = {}) {
    if (!options.hasOwnProperty('isReFlush')) {
      options.isReFlush = false
    }
    if (!options.hasOwnProperty('isPush')) {
      options.isPush = true
    }
    let dropList = {}
    dropList.user = []
    dropList.select = ''
    return new Promise(async (resolve, reject) => {
      console.log("就诊人列表=>", state.userInfoList);
      if (state.userInfoList.length > 0 && !options.isReFlush) {
        for (let [index, item] of state.userInfoList.entries()) {
          const user = {
            text: item.name,
            value: index,
            id: item.id,
            medical_card: item.medical_card,
          };
          dropList.user.push(user);
          if (item.is_default === 1) {
            dropList.select = index;
          }
        }
        //这里的是就诊人下拉列表展示的默认就诊人 
        //有就诊人且全部is_default都为0 没有默认就诊人 拿第一个为默认就诊人
        if (state.userInfoList.every((item) => item.is_default === 0)){
          dropList.select = 0;
        }

        resolve(true)
        commit('setUserInfo', findDefaultUser(state.userInfoList))
        commit('setUserDropList', dropList)
      } else {
        await getPatientlist().then((res) => {
          if (!Array.isArray(res)) {
            // reject('返回的就诊人列表必须是一个数组')
            console.log('返回的就诊人列表必须是一个数组')
            reject('')
          }
          if (res.length > 0) {
            for (let [index, item] of res.entries()) {
              const user = {
                text: item.name,
                value: index,
                id: item.id,
                medical_card: item.medical_card,
              };
              dropList.user.push(user);
              if (item.is_default === 1) {
                dropList.select = index;
              }
            }
           //这里的是就诊人下拉列表展示的默认就诊人 
           //有就诊人且全部is_default都为0 没有默认就诊人 拿第一个为默认就诊人
            if (res.every((item) => item.is_default === 0)){
              dropList.select = 0;
            }
            
            commit('setUserDropList', dropList)
            commit('setUserInfoList', res)
            commit('setUserInfo', findDefaultUser(res))
            resolve(res)
          } else {
            if (options.isPush) {
              v.$toast('还没有就诊人，请先绑定')
              router.push({ name: 'selectlogin' })
            }
            reject(false)
          }
        }).catch((e) => {
          v.$toast(e)
          reject(false)
        })
      }
    })
  },

  //检查是否有默认就诊人
  async checkHasUser({ state, dispatch }) {
    return new Promise(async (resolve, reject) => {
      await dispatch('getAllUser').then(() => {
        resolve(true)
      }).catch(() => {
        reject(false)
      })
    })
  },


}
